var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-container',{staticClass:"asc-release-notes-template"},[_c('asc-spinner-wrapper',{attrs:{"loading":_vm.loading}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.releaseNotes)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }